
<template>
  <div>
    <a-row :gutter="24">
      <a-col :md="16">
        <a-form-item label="身份证照片" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <div style="display: flex;">
            <a-upload
              name="avatar"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              :customRequest="fileUpdate1"
              :before-upload="beforeUpload1"
            >
            <span class="del" @click.stop="delfn('imageUrl1')" v-if="selectFrom.imageUrl1">x</span>
              <img v-if="selectFrom.imageUrl1" style="width: 250px; height: 140px" :src="selectFrom.imageUrl1" alt="" />
              <div v-else>
                <a-icon type="plus" />
              </div>
            </a-upload>
            <a-upload
              name="avatar"
              list-type="picture-card"
              class="avatar-uploader2"
              :show-upload-list="false"
              :customRequest="fileUpdate2"
              :before-upload="beforeUpload2"
            >
            <span class="del" @click.stop="delfn('imageUrl2')" v-if="selectFrom.imageUrl2">x</span>
              <img v-if="selectFrom.imageUrl2" style="width: 250px; height: 140px" :src="selectFrom.imageUrl2" alt="" />
              <div v-else>
                <a-icon type="plus" />
              </div>
            </a-upload>

          </div>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="24">
      <a-col :md="16">
        <a-form-item label="" >
          <div class="cardBody">
            <span :class="selectFrom.imageUrl1 ? 'card-front' : ''" >身份证人像面</span>
            <span :class="selectFrom.imageUrl2 ? 'card-side' : 'card-side1'">身份证国徽面</span>

          </div>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="24">
      <a-col :md="16">
        <a-form-item label="医师执业证书" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <div style="display: flex">
            <a-upload
              name="avatar"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              :customRequest="fileUpdate3"
              :before-upload="beforeUpload3"
            >
            <span class="del" @click.stop="delfn('imageUrl3')" v-if="selectFrom.imageUrl3">x</span>
              <img v-if="selectFrom.imageUrl3" style="width: 250px; height: 140px" :src="selectFrom.imageUrl3" alt="" />
              <div v-else>
                <a-icon type="plus" />
              </div>
            </a-upload>
            <a-upload
              name="avatar"
              list-type="picture-card"
              class="avatar-uploader2"
              :show-upload-list="false"
              :customRequest="fileUpdate4"
              :before-upload="beforeUpload4"
            >
            <span class="del" @click.stop="delfn('imageUrl4')" v-if="selectFrom.imageUrl4">x</span>
              <img v-if="selectFrom.imageUrl4" style="width: 250px; height: 140px" :src="selectFrom.imageUrl4" alt="" />
              <div v-else>
                <a-icon type="plus" />
              </div>
            </a-upload>
          </div>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="24">
      <a-col :md="16">
        <a-form-item label="职称资格证书" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <div style="display: flex">
            <a-upload
              name="avatar"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              :customRequest="fileUpdate5"
              :before-upload="beforeUpload5"
            >
            <span class="del" @click.stop="delfn('imageUrl5')" v-if="selectFrom.imageUrl5">x</span>
              <img v-if="selectFrom.imageUrl5" style="width: 250px; height: 140px" :src="selectFrom.imageUrl5" alt="" />
              <div v-else>
                <a-icon type="plus" />
              </div>
            </a-upload>
            <a-upload
              name="avatar"
              list-type="picture-card"
              class="avatar-uploader2"
              :show-upload-list="false"
              :customRequest="fileUpdate6"
              :before-upload="beforeUpload6"
            >
            <span class="del" @click.stop="delfn('imageUrl6')" v-if="selectFrom.imageUrl6">x</span>
              <img v-if="selectFrom.imageUrl6" style="width: 250px; height: 140px" :src="selectFrom.imageUrl6" alt="" />
              <div v-else>
                <a-icon type="plus" />
              </div>
            </a-upload>
          </div>
        </a-form-item>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { STable } from '@/components'
import moment from 'moment'
import { pictureUpdate } from '@/api/modular/interhospital/medicalOrg/medicalOrgManage'
export default {
  components: {
    STable,
  },
  props: {
    selectFrom: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      labelCol_two: {
        xs: { span: 24 },
        sm: { span: 1 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 19 },
      },
      // selectFrom: {
      //   imageUrl1: null,
      //   imageUrl2: null,
      //   imageUrl3: null,
      //   imageUrl4: null,
      //   imageUrl5: null,
      //   imageUrl6: null,
      // },
    }
  },
  watch: {
    selectFrom(n, o) {
      console.log('数据改变', n, o)
      // this.weekInfoItem = n
    },
  },
  methods: {
    moment,
    // 自定义文件上传
    beforeUpload1(file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      console.log('图片大小',isLt2M,file.size, file.size / 1024 / 1024)
      if (!isLt2M) {
        this.$message.error('建议上传单个图片大小不超过2MB!')
        return
      }
      const reader = new FileReader()
      // 把Array Buffer转化为blob 如果是base64不需要
      // 转化为base64
      reader.readAsDataURL(file)
      reader.onload = () => {
        console.log('转化为base64',reader.result)
        this.selectFrom.imageUrl1 = reader.result
        this.$emit('addSelect', this.selectFrom)
      }
      return isLt2M
    },
    beforeUpload2(file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('建议上传图片大小不超过2MB!')
      }
      const reader = new FileReader()
      // 把Array Buffer转化为blob 如果是base64不需要
      // 转化为base64
      reader.readAsDataURL(file)
      reader.onload = () => {
        console.log('转化为base64',reader.result)
        this.selectFrom.imageUrl2 = reader.result
        this.$emit('addSelect', this.selectFrom)
      }
      return isLt2M
    },
    beforeUpload3(file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('建议上传图片大小不超过2MB!')
      }
      const reader = new FileReader()
      // 把Array Buffer转化为blob 如果是base64不需要
      // 转化为base64
      reader.readAsDataURL(file)
      reader.onload = () => {
        console.log('转化为base64',reader.result)
        this.selectFrom.imageUrl3 = reader.result
        this.$emit('addSelect', this.selectFrom)
      }
      return isLt2M
    },
    beforeUpload4(file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('建议上传图片大小不超过2MB!')
      }
      const reader = new FileReader()
      // 把Array Buffer转化为blob 如果是base64不需要
      // 转化为base64
      reader.readAsDataURL(file)
      reader.onload = () => {
        console.log('转化为base64',reader.result)
        this.selectFrom.imageUrl4 = reader.result
        this.$emit('addSelect', this.selectFrom)
      }
      return isLt2M
    },
    beforeUpload5(file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('建议上传图片大小不超过2MB!')
      }
      const reader = new FileReader()
      // 把Array Buffer转化为blob 如果是base64不需要
      // 转化为base64
      reader.readAsDataURL(file)
      reader.onload = () => {
        console.log('转化为base64',reader.result)
        this.selectFrom.imageUrl5 = reader.result
        this.$emit('addSelect', this.selectFrom)
      }
      return isLt2M
    },
    beforeUpload6(file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('建议上传图片大小不超过2MB!')
      }
      const reader = new FileReader()
      // 把Array Buffer转化为blob 如果是base64不需要
      // 转化为base64
      reader.readAsDataURL(file)
      reader.onload = () => {
        console.log('转化为base64',reader.result)
        this.selectFrom.imageUrl6 = reader.result
        this.$emit('addSelect', this.selectFrom)
      }
      return isLt2M
    },
    fileUpdate1(file) {
      console.log('获取图片', file)
      const form = new FormData()
      form.append('file', file.file)
      pictureUpdate(form).then((res) => {
        if (res.code == 200) {
          // this.selectFrom.imageUrl1 = res.data
        } else {
          this.$message.error('上传图片失败')
        }
      })
    },
    fileUpdate2(file) {
      const form = new FormData()
      form.append('file', file.file)
      pictureUpdate(form).then((res) => {
        if (res.code == 200) {
          // this.selectFrom.imageUrl2 = res.data
        } else {
          this.$message.error('上传图片失败')
        }
      })
    },
    fileUpdate3(file) {
      const form = new FormData()
      form.append('file', file.file)
      pictureUpdate(form).then((res) => {
        if (res.code == 200) {
          // this.selectFrom.imageUrl3 = res.data
        } else {
          this.$message.error('上传图片失败')
        }
      })
    },
    fileUpdate4(file) {
      const form = new FormData()
      form.append('file', file.file)
      pictureUpdate(form).then((res) => {
        if (res.code == 200) {
          // this.selectFrom.imageUrl4 = res.data
        } else {
          this.$message.error('上传图片失败')
        }
      })
    },
    fileUpdate5(file) {
      const form = new FormData()
      form.append('file', file.file)
      pictureUpdate(form).then((res) => {
        if (res.code == 200) {
          // this.selectFrom.imageUrl5 = res.data
        } else {
          this.$message.error('上传图片失败')
        }
      })
    },
    fileUpdate6(file) {
      const form = new FormData()
      form.append('file', file.file)
      pictureUpdate(form).then((res) => {
        if (res.code == 200) {
          // this.selectFrom.imageUrl6 = res.data
        } else {
          this.$message.error('上传图片失败')
        }
      })
    },
    delfn(delSelect){
      this.selectFrom[delSelect] = '';
      this.$emit('addSelect', this.selectFrom)
    }
  },
}
</script>

<style lang="less" scoped>
  .cardBody{
    display: flex;
    margin-left: 23%;
    width: 100%;
    .card-front{
     width: 250px;
     text-align: center;

    }
    .card-side{
      width: 360px;
      text-align: center;
    }
    .card-side1{
      margin-left: 80px;
    }
  }
.avatar-uploader {
  position: relative;
  margin-right: 50px;


  .del{
    width: 18px;
    height: 18px;
    border-radius: 18px;
    background: #ff0000;
    color: #fff;
    position: absolute;
    right: 0px;
    top: -9px;
    display: inline-block;
    line-height: 13px;
    font-size: 14px;
    text-align: center;
    cursor: pointer;


  }
}
.avatar-uploader2 {
  position: relative;
  .del{
    width: 18px;
    height: 18px;
    border-radius: 18px;
    background: #ff0000;
    color: #fff;
    position: absolute;
    right: 0px;
    top: -9px;
    display: inline-block;
    line-height: 13px;
    font-size: 14px;
    text-align: center;
    cursor: pointer;


  }
}
</style>
